import makeService from './api';

export default makeService('animation_categories');
